import {useCallback, useEffect, useState} from 'react';
import sdk from '@/sdk';
import {standardRequest} from '@/sdk/common/request';
import {ServerConfig} from '@/config/routers';
import {addFrontTraceInfo} from '@/sdk/common/addFrontTraceInfo';
import axios from 'axios';
import {STATUS} from '@/Constant';

export function useTemplateJson({
    id,
    rteId,
    spaceGuid,
    groupGuid,
    repositoryGuid,
}: {
    id: string;
    rteId: string;
    spaceGuid?: string;
    groupGuid?: string;
    repositoryGuid?: string;
}, json: any) {
    const [htmlJson, setHtmlJson] = useState(json);
    const [status, setStatus] = useState('');

    const getHtmlJson = useCallback(async () => {
        try {
            if (!spaceGuid || !groupGuid || !repositoryGuid) {
                return;
            }
            setStatus(STATUS.loading);
            const ksServer = await sdk.getKsServer({
                spaceGuid,
                groupGuid,
                repositoryGuid,
            });
            const token = await ksServer.getTemplateToken(id, 15 * 1000);
            const params = {
                appId: 1,
                ignoreContent: 0,
            };
            const res = await axios(
                {
                    method: 'get',
                    url: `${ServerConfig.rte}/api/v1/knowledge/${rteId}/versions/NEWEST`,
                    params,
                    headers: {
                        Authorization: token,
                    },
                }
            );
            if (res?.data?.code === 200) {
                if (res.data.data?.content?.children) {
                    setHtmlJson(res.data.data?.content?.children);
                    setStatus(STATUS.success);
                } else {
                    setStatus(STATUS.error);
                }
            } else {
                setStatus(STATUS.error);
            }
        } catch (err) {
            console.log(err);
            setStatus(STATUS.error);
        }
    }, [groupGuid, id, repositoryGuid, rteId, spaceGuid]);

    useEffect(() => {

        if (!json) {
            getHtmlJson();
        }
    }, [getHtmlJson, json]);

    function onRetry() {
        if (status === STATUS.loading) {
            return;
        }
        getHtmlJson();
    }

    return {htmlJson, status, onRetry};
}
